/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ source: NonNullable<unknown> }} Recipe_Source_OnInputs */

const en_recipe_source_on = /** @type {(inputs: Recipe_Source_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.source}`)
};

const de_recipe_source_on = /** @type {(inputs: Recipe_Source_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Von ${i?.source}`)
};

/**
* | output |
* | --- |
* | "From {source}" |
*
* @param {Recipe_Source_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_source_on = /** @type {((inputs: Recipe_Source_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Source_OnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_source_on(inputs)
	return en_recipe_source_on(inputs)
});